import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "trial-badge" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'TrialBadge',
  props: {
    days: {},
    compact: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.days === null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "No free trial"))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(__props.days) + "-day free trial", 1),
          (!__props.compact)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" included")
              ], 64))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})